@if (account()) {
  <button
    type="button"
    [bitMenuTriggerFor]="accountMenu"
    class="bv-profile-menu-trigger tw-shrink-0 tw-border-0 tw-bg-transparent tw-p-0"
  >
    <dynamic-avatar [id]="account().id" [text]="account() | userName"></dynamic-avatar>
  </button>

  <bit-menu #accountMenu>
    <div class="bv-profile-menu" appStopProp>
      <div class="bv-profile-menu__header">
        <dynamic-avatar [id]="account().id" [text]="account() | userName"></dynamic-avatar>
        <div class="bv-profile-menu__identity">
          <span class="bv-profile-menu__label">{{ "loggedInAs" | i18n }}</span>
          <span class="bv-profile-menu__name">{{ account() | userName }}</span>
        </div>
      </div>

      @if (selfHosted) {
        <bit-menu-divider></bit-menu-divider>
        <div class="bv-profile-menu__hostname">{{ hostname }}</div>
      }

      <bit-menu-divider></bit-menu-divider>

      <a bitMenuItem routerLink="/settings/account">
        <span
          slot="start"
          class="bv-profile-menu__icon bv-profile-menu__icon--account"
          aria-hidden="true"
        ></span>
        {{ "accountSettings" | i18n }}
      </a>
      <button bitMenuItem type="button" disabled>
        <span
          slot="start"
          class="bv-profile-menu__icon bv-profile-menu__icon--help"
          aria-hidden="true"
        ></span>
        {{ "getHelp" | i18n }}
      </button>
      <button bitMenuItem type="button" disabled>
        <span
          slot="start"
          class="bv-profile-menu__icon bv-profile-menu__icon--download"
          aria-hidden="true"
        ></span>
        {{ "getApps" | i18n }}
      </button>

      <bit-menu-divider></bit-menu-divider>

      @if (canLock$ | async) {
        <button bitMenuItem type="button" (click)="lock()">
          <span
            slot="start"
            class="bv-profile-menu__icon bv-profile-menu__icon--lock"
            aria-hidden="true"
          ></span>
          {{ "lockNow" | i18n }}
        </button>
      }

      <button bitMenuItem type="button" (click)="logout()">
        <span
          slot="start"
          class="bv-profile-menu__icon bv-profile-menu__icon--logout"
          aria-hidden="true"
        ></span>
        {{ "logOut" | i18n }}
      </button>
    </div>
  </bit-menu>
}
